export enum AppTransactionRowState {
  Success = 'success',
  Pending = 'pending',
  Cancelled = 'cancelled',
}
